<pcs-icon
  *ngIf="hasIcon()"
  class="icon"
  [icon]="getIcon()">
</pcs-icon>

<ng-container *ngIf="extended">
  <span>{{agency.shortName}}</span>
</ng-container>
